// extracted by mini-css-extract-plugin
export default {"paddingBlock":"SidebarAtendimento_paddingBlock__S5k9B","sideBarBlockPd":"SidebarAtendimento_sideBarBlockPd__JcuZP"};